import {
	GetMapByPublicQuery,
	GetMapByPublicQueryVariables,
} from "~map-view/types/__generated/gql/graphql";
import { graphierQLNextClient } from "~utils/api/graphierQLNextClient";

const query = /* GraphQL */ `
	fragment SymbolStyleFragment on SymbolStyle {
		name
		isGraphic
		basic {
			size
			rotation
			symbol
			radius
			opacity
		}
		fill {
			width
			fillType
			style
			color
			opacity
			isDisabled
		}
		stroke {
			style
			color
			width
			opacity
			isDisabled
		}
	}

	fragment SymbolValueFragment on SymbolValue {
		color
		value
		label
		count
		symbol {
			...SymbolStyleFragment
		}
		id
		range
		legendVisibility
		min
		max
	}

	query GetMapByPublic($id: ID!) {
		getMapByPublic(id: $id) {
			id
			createdAt
			updatedAt
			name
			description
			userId
			baseMapId
			layerGroupCollection {
				total
				items {
					id
					createdAt
					updatedAt
					mapId
					visible
					position
					layerCollection {
						total
						items {
							id
							createdAt
							updatedAt
							name
							description
							minZoom
							maxZoom
							position
							visible
							datasetId
							layerGroupId
							dataType
							styleType
							labelsStyle {
								attribute
								font
								fontSize
								fontColour
								fontOpacity
								haloColour
								haloOpacity
								haloSize
							}
							lineSimpleStyle {
								symbolStyle {
									...SymbolStyleFragment
								}
							}
							lineCategoryStyle {
								colorRamp
								symbolStyle {
									...SymbolStyleFragment
								}
								valueField
								symbolValues {
									...SymbolValueFragment
								}
							}
							polygonCategoryStyle {
								colorRamp
								symbolStyle {
									...SymbolStyleFragment
								}
								valueField
								symbolValues {
									...SymbolValueFragment
								}
							}
							lineQuantityStyle {
								valueField
								legendType
								classNumber
								colorRamp
								classification
								symbolStyle {
									...SymbolStyleFragment
								}
								symbolValues {
									...SymbolValueFragment
								}
								classbreaks
							}
							pointSimpleStyle {
								symbolStyle {
									...SymbolStyleFragment
								}
							}
							pointCategoryStyle {
								colorRamp
								symbolStyle {
									...SymbolStyleFragment
								}
								valueField
								symbolValues {
									...SymbolValueFragment
								}
							}
							pointQuantityStyle {
								valueField
								legendType
								classNumber
								colorRamp
								classification
								symbolStyle {
									...SymbolStyleFragment
								}
								symbolValues {
									...SymbolValueFragment
								}
								classbreaks
							}
							heatMapStyle {
								basic {
									radius
									opacity
								}
							}
							polygonSimpleStyle {
								symbolStyle {
									...SymbolStyleFragment
								}
							}
							bubbleStyle {
								valueField
								classNumber
								classification
								radius {
									min
									max
								}
								symbolStyle {
									...SymbolStyleFragment
								}
								symbolValues {
									...SymbolValueFragment
								}
							}
							polygonQuantityStyle {
								valueField
								legendType
								classNumber
								colorRamp
								classification
								symbolStyle {
									...SymbolStyleFragment
								}
								symbolValues {
									...SymbolValueFragment
								}
								classbreaks
							}

							_dataset {
								id
								createdAt
								updatedAt
								name
								description
								userId
								type
								datasourceType
								sourceDatasetId
								size
								mapsCount
								legendUrl
								getCapabilitiesUrl
								bbox
							}
						}
					}
				}
			}
			isPublic
			groupsAccesses {
				id
				viewable
				editable
			}
			publicAccessConfigs {
				type
				password
				hiddenId
			}
			embedConfigs {
				loadType
				mapConfigs
			}
			tool {
				query
				search
				mousePosition
				scaleBar
				streetView
				legend
				measure
				customSearch
				geolocation
				print
				bookmarks
				proximity
				sketch
				resetMap
				shareMap
			}
		}
	}
`;

export const getMapByPublic = (variables: GetMapByPublicQueryVariables) =>
	graphierQLNextClient<GetMapByPublicQuery, GetMapByPublicQueryVariables>({
		query,
		variables,
		useKey: true,
	}).then((res) => res.getMapByPublic);
